import { RootState } from '../../interfaces/rootState';

const AppAlertSelector = ({ appAlert }: RootState) => appAlert;

export default AppAlertSelector;
